import { useMediaQuery, useTheme } from "@mui/material";

/**
 * Below md the shell switches to its phone layout: the nav rail becomes an overlay drawer and the
 * topbar collapses to a menu button, the title and one account button. VPs and the CEO mostly open
 * sign-off links on their phones, so this is the layout that page is read in.
 */
export const useIsMobileLayout = () => {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.down("md"));
};
